import script from "./TinyToggle.vue?vue&type=script&setup=true&lang=js"
export * from "./TinyToggle.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac0d0904"]])

export default __exports__